export default "__VITE_ASSET__f64cf7bb__"